import React from 'react';
import { setDisplayName } from 'recompose';

import 'normalize.css';
import './styles.global.css';

const BaseLayout = ({ children }: Props) => (
  <div>
    { children }
  </div>
);

export default BaseLayout;

type Props = {
  children?: any
}
